<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item">招待履歴</li>
            </ol>
        </nav>
        <div class="container">
            <div class="text-muted small p-2 my-2">
                あなたのリンクからユーザー登録が行われた履歴です。<br>
                どの作品のエイジングが回復したかをリストします。
                当該作品を削除した場合、履歴も削除されます。
            </div>
            <div v-if="canAd">
                <div class="affiliate-title">
                    貸し本棚を紹介する
                </div>
                <div class="row mb-3">
                    <div class="col-md-3 p-1">
                        <a :href="'https://bsky.app/intent/compose?text='+enc(tweet)" target="_blank" class="btn btn-twitter btn-block btn-icon">
                            <img src="/img/bluesky-white.svg">
                            Blueskyで紹介する
                        </a>
                    </div>
                    <div class="col-md-3 p-1">
                        <a :href="'https://taittsuu.com/share?text='+enc(tweet)" target="_blank" class="btn btn-secondary btn-block btn-icon nowrap">
                            <img src="/img/taittsuu.png">
                            タイッツーで紹介する
                        </a>
                    </div>
                    <div class="col-md-3 p-1">
                        <a :href="'https://x.com/intent/tweet?text='+enc(tweet)+'&hashtags='+enc('貸し本棚')" target="_blank" class="btn btn-dark btn-block btn-icon">
                            <i class="fab fa-twitter"></i>
                            Xで紹介する
                        </a>
                    </div>
                    <div class="col-md-3 p-1">
                        <a :href="'https://www.facebook.com/sharer.php?u='+enc(url)" target="_blank" class="btn btn-facebook btn-block btn-icon">
                            <i class="fab fa-facebook-square"></i>
                            Facebookで紹介する
                        </a>
                    </div>
                </div>
                <div class="mb-3">
                    以下をリンク先にすることで、様々な場所に紹介リンクを設置できます。
                    <input type="text" :value="url" readonly class="form-control">
                </div>
                <div class="text-center small py-2">
                    <router-link to="/help/other/share">貸し本棚の宣伝について</router-link>
                </div>
            </div>
            <div class="sticky">
                <page :last_page="recovers.last_page" v-model="page" @goto="goto"></page>
            </div>
            <div class="card my-2" v-for="r in recovers.data" :key="r.id">
                <div class="card-body">
                    <h5 class="card-title">
                        {{r.book.title}}
                    </h5>
                    <div class="card-text">
                        <span class="badge badge-pill" :class="{
                            'badge-success': r.action === 'ユーザー登録',
                            'badge-info': r.action !== 'ユーザー登録',
                        }">{{r.action}}</span>
                        {{$filters.numberFormat(r.org_pvs)}} → {{$filters.numberFormat(r.new_pvs)}}
                    </div>
                    <div class="small">
                        {{$filters.dateFormat(r.created_at, 'YYYY年MM月DD日 HH時')}}
                        <span class="badge badge-secondary" v-if="!r.invitee_id">退会ユーザ</span>
                    </div>
                </div>
            </div>
            <div class="my-2" v-if="recovers.total == 0">
                招待履歴はありません。
            </div>
        </div>
    </div>
</template>

<style scoped>

.btn-icon
{
    img {
        width: 16px;
        height: 16px;
    }
    &:hover {
        img {
            filter: brightness(2);
        }
    }
}
</style>

<script>
import page from "components/Page";
export default {
    components: {
        page
    },
    data() {
        return {
            page: 1,
            recovers: [],
        }
    },
    methods: {
        goto(p) {
            this.page = p;
            setTimeout(() => {this.load()});
        },
        load() {
            axios.get("/mypage/recovers/get", {params: {page: this.page}}).then(res => {
                this.recovers = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        enc(string) {
            return encodeURI(string);
        }
    },
    computed: {
        url() {
            return `https://www${this.$store.state.base_domain}/?ad_token=${this.$store.state.user?.ad_token}`;
        },
        quote() {
            return `Web小説家のための小説保管サイト\n`;
        },
        tweet() {
            return this.quote + "\n" + this.url;
        },
        canAd() {
            return this.$store.state.user?.email_verified_at && this.$store.state.user?.ad_token;
        }
    },
    mounted() {
        this.load();
    }
}
</script>